/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_0dFAWkOrw",
    "aws_user_pools_web_client_id": "53qbiq9b9d85ocg9u3envn7pdf",
    "oauth": {}
};


export default awsmobile;
